import { useEffect, useState, useCallback } from 'react';
import Table from 'components/generics/Table/ReactTable';
import { FLIGHTIMES_STATS_HEADERS } from 'utils/const';
import { formatMinutesToHour, prepareTable } from 'utils/func';
import './FlightTimesStats.style.scss';
import InputLabel from 'components/generics/InputLabel/InputLabel';
import Input from 'components/generics/Input/Input';
import { getFlightTimes } from 'services/API/Stats';
import Bar from '../../../generics/Charts/Bar';
import { Loader } from '../../../generics/Loader/Loader';

const FlightTimesStats = () => {
  const [data, setData] = useState(null);
  const [filteredData, setFilteredData] = useState([]);
  const [arrayData, setArrayData] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [filter, setFilter] = useState('');
  const [loading, setLoading] = useState(true);
  const [tableKey, setTableKey] = useState(0);

  useEffect(() => {
    getFlightTimes()
      .then(res => {
        setData({
          datas: prepareTable(FLIGHTIMES_STATS_HEADERS, res.data.aircrafts),
          headers: FLIGHTIMES_STATS_HEADERS,
        });
        setLoading(false);
      })
      .catch(err => console.error(err));
  }, []);

  useEffect(() => {
    if (data) {
      const filteredData = data.datas.filter(item => item.reg.toLowerCase().includes(filter.toLowerCase()));
      setFilteredData(filteredData);
      const formattedArray = filteredData.map(item => ({
        ...item,
        totalMinutesFlightTimeUtc: formatMinutesToHour(item.totalMinutesFlightTimeUtc),
        totalMinutesFlightTimeTlb: formatMinutesToHour(item.totalMinutesFlightTimeTlb),
        contractPlannedHours: item.contractPlannedHours,
        remainingMinutes: formatMinutesToHour(item.remainingMinutes),
      }));
      setArrayData(formattedArray);
      // Réinitialiser la table pour forcer la sélection de toutes les lignes
      setTableKey(prev => prev + 1);
    }
  }, [filter, data]);

  const handleSelectedRows = useCallback((rows) => {
    setSelectedRows(rows.map(row => row.original));
  }, []);

  const formatChartData = data => {
    return data.map(v => ({
      reg: v.reg,
      totalMinutesFlightTimeUtc: Math.round(parseFloat(v.totalMinutesFlightTimeUtc) || 0),
      totalMinutesFlightTimeTlb: Math.round(parseFloat(v.totalMinutesFlightTimeTlb) || 0),
      contractPlannedHours: Math.round(parseFloat(v.contractPlannedHours) || 0),
      remainingMinutes: Math.round(parseFloat(v.remainingMinutes) || 0),
    }));
  };

  return (
    <div id="FlightTimesStats">
      {loading ? (
        <Loader />
      ) : (
        <>
          <div className="statsContainer">
            <div id="table">
              <InputLabel label="Reg filter" name="reg">
                <Input type="text" name="reg" placeholder="Enter a registration" defaultStyle="primary" onChange={setFilter} />
              </InputLabel>
              <Table 
                key={tableKey}
                selectedRows={handleSelectedRows} 
                datas={arrayData} 
                headers={data.headers} 
                filters={false} 
                selectable={true} 
                name="flightTimesFilters" 
                initialSelectAll={true}
              />
            </div>
            <div className="statsSection" id="chart">
              <h3>Aircraft hours</h3>
              <div className="graphContainer">
                <Bar
                  data={formatChartData(selectedRows)}
                  keys={['totalMinutesFlightTimeUtc', 'totalMinutesFlightTimeTlb', 'contractPlannedHours', 'remainingMinutes']}
                  legends={['Planned hours', 'Tlb hours', 'Contracted hours', 'Remaining hours']}
                  labels={['Planned hours', 'Tlb hours', 'Contracted hours', 'Remaining hours']}
                  mode={'grouped'}
                  indexBy={'reg'}
                  colors={['#03A9F4', '#016593', '#4ec6fd', '#029ce3', '#01577e']}
                />
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default FlightTimesStats;
